//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { PopularProductsService } from "@nuskin/ns-product";
import { getRecommendations } from "@nuskin/product-recommendation";
import { NsCarousel } from "@nuskin/design-components";
import { CartService } from "@nuskin/ns-shop";

import NsProductCard from "./NsProductCard.vue";

// MIN_WIDTH equals left and right controls plus 3 product cards at 230px each
const MIN_WIDTH = 800;

/**
 * NsProductCarousel
 *
 */

export default {
  name: "NsProductCarousel",
  components: {
    NsCarousel,
    NsProductCard
  },
  props: {
    /**
     * An array of skus to show in the carousel
     */
    skus: {
      type: Array,
      default: () => []
    },
    /**
     * The type of carousel
     * @values undefined, recommended, popular
     */
    type: {
      type: String,
      default: ""
    },
    /**
     * Force points to show in product cards
     */
    forcesv: Boolean,
    /**
     * Hide the Exclusive Icon in product cards
     */
    hideExclusiveIcon: Boolean,
    /**
     * Hide the Exclusive Text on Mobile in product cards
     */
    hideExclusiveTextOnMobile: Boolean,
    /**
     * Hide the Favorites Icon in product cards
     */
    hideFavorites: Boolean,
    /**
     * Hide the Sku number in product cards
     */
    hideSku: Boolean,
    /**
     * Disable the action dropdown in product cards
     */
    noAction: Boolean
  },
  data() {
    return {
      localSkus: this.type ? [] : this.skus,
      showControls: true,
      carouselStyle: ""
    };
  },
  computed: {
    phabletAndDown() {
      return this.$mq === "phablet" || this.$mq === "mobile";
    }
  },
  watch: {
    skus(value) {
      if (!this.type) {
        this.localSkus = value;
      }
    },
    type: {
      immediate: true,
      handler(newVal) {
        this.setSkusByType(newVal);
      }
    }
  },
  mounted() {
    window.addEventListener("resize", this.checkMinWindowSize);
    this.$nextTick(() => {
      this.checkMinWindowSize();
    });
  },
  destroyed() {
    window.removeEventListener("resize", this.checkMinWindowSize);
  },
  methods: {
    checkMinWindowSize() {
      if (
        this.$refs.container &&
        this.$refs.container.clientWidth < MIN_WIDTH
      ) {
        this.showControls = false;

        // Carousel should stop centering at MIN_WIDTH minus controls (90px)
        if (this.$refs.container.clientWidth < MIN_WIDTH - 90) {
          this.carouselStyle = "justify-content: flex-start;";
        } else {
          this.carouselStyle = "";
        }
      } else {
        this.showControls = true;
      }
    },
    setSkusByType(type) {
      switch (type) {
        case "recommended":
          this.setSkusWithRecommendedProducts();
          break;
        case "popular":
          this.setSkusWithPopularProducts();
          break;
        default:
          this.localSkus = this.skus;
      }
    },
    async setSkusWithRecommendedProducts() {
      try {
        let options = {};
        let unique = [];
        let cartSkus = [];

        if (CartService.getItemData().length > 0) {
          cartSkus = CartService.getItemData().map(item => item.sku);
          options.productSkus = cartSkus;
        }

        let recommendedProducts = await getRecommendations(options);
        if (recommendedProducts) {
          recommendedProducts.sort((a, b) => (a.type > b.type ? 1 : -1));

          unique = Array.from(
            new Set(recommendedProducts.map(item => item.sku))
          )
            .map(sku => {
              return {
                sku: sku,
                type: recommendedProducts.find(item => item.sku === sku).type
              };
            })
            .filter(item => !cartSkus.includes(item.sku));

          this.localSkus = unique.map(recommendation => recommendation.sku);
        }
      } catch (err) {
        console.log(err);
        this.localSkus = [];
      }
    },
    async setSkusWithPopularProducts() {
      const popularProducts = await PopularProductsService.getPopularProducts();
      if (popularProducts) {
        this.localSkus = popularProducts.Items.map(
          popularProduct => popularProduct.sku
        );
      } else {
        this.localSkus = [];
      }
    }
  }
};
